import fp from 'lodash/fp';
import { handleActions } from 'redux-actions';
import { configurations } from './configurations';

export const initialState = {
  contentResult: {
    content: [],
    total: 0,
    hits: 0,
    take: 0,
    skip: 0
  },
  isFetching: false,
  isLoadingMore: false,
  error: null
};

const reducer = handleActions(
  fp.flow(
    fp.map(
      ({ reducers: { reducer, request, success, failed }, action: { content: { api, ...action } }, name }) => {
        var result = {}
        if (reducer) {
          result = {
            ...result,
            [action[name]().type]: reducer
          }
        }
        if (request) {
          result = {
            ...result,
            [api[name].request]: request
          }
        }
        if (success) {
          result = {
            ...result,
            [api[name].success]: success
          }
        }
        if (failed) {
          result = {
            ...result,
            [api[name].failed]: failed
          }
        }
        return result
      }
    ),
    fp.reduce(
      (prev, current) => ({
        ...prev,
        ...current
      }),
      {}
    )
  )(configurations), {
    ...initialState
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/content/reducers.js